import { Col } from '../grid';
export default Col;
//# sourceMappingURL=index.js.map
